import React from 'react';
import { IItemForGetShortInfo } from 'types';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';
import style from './index.module.scss';

interface IProps {
	setAdditionalRestaurants: (value: string[]) => void;
	selectedAdditionalRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurant: Nullable<string>;
}

export const RestaurantsBlock: React.FC<IProps> = React.memo(
	({ setAdditionalRestaurants, selectedAdditionalRestaurants, fetchedRestaurants, IDSelectedRestaurant }) => {
		return (
			<div className={style.container}>
				<div className={style.fieldWrapper}>
					<div className={style.heading}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<Text
							className={style.hint}
							translationNameSpace="form"
							translationKey="restaurantSelectHint"
							theme="secondaryLight"
							size="s"
							weight="bold"
						/>
					</div>
					<Text
						translationNameSpace="form"
						translationKey="descriptionForFinishPortionCreation"
						theme="neutralLight"
						size="s"
					/>
					<RestaurantMultipleSelect
						setAdditionalRestaurants={setAdditionalRestaurants}
						selectedAdditionalRestaurants={selectedAdditionalRestaurants}
						fetchedRestaurants={fetchedRestaurants}
						IDSelectedRestaurant={IDSelectedRestaurant}
					/>
				</div>
			</div>
		);
	},
);
